// extracted by mini-css-extract-plugin
module.exports = {"FloatingBanner":"FloatingBanner_FloatingBanner__Bl5vf","highlight":"FloatingBanner_highlight__25ak9"};